import script from "./DepartmentsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentsList.vue?vue&type=script&setup=true&lang=ts"

import "./DepartmentsList.vue?vue&type=style&index=0&id=012092cc&lang=css"
import "./DepartmentsList.vue?vue&type=style&index=1&id=012092cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012092cc"]])

export default __exports__